import React, { useState } from "react";
import { Grid, Card, Icon, FileDrop, Modal, Button } from "@scuf/common";
import baseServices from "../../services/base.services";
import TitlePage from "../../components/TitlePage/TitlePage";

import "./CargaData.css";

const CargaData = () => {
  const [data, setData] = useState(null);
  const [stateModal, setStateModal] = useState(false);

  const fUpload = async (file, planilla) => {
    var formData = new FormData();
    formData.append("archivo", file);
    formData.append("nombreArchivo", "tostacionDMH.xlsx");
    formData.append("path", "upload/tostacion");
    formData.append("planilla", planilla);

    try {
      var response = await baseServices.postTostacionUpload(formData);
      if (response) {
        setStateModal(true);
      } else {
        console.log(response);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fGlobal = (titulo, planilla) => {
    return (
      <Card>
        <Card.Content>
          <Grid className="m-0 p-0">
            <Grid.Row>
              <div className="value-staticts-custom text-white text-start ps-2">
                {titulo}
              </div>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column width={12} className="m-0 p-0">
                <FileDrop
                  acceptedTypes={[
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  ]}
                  maxSize={50000000}
                  buttonText={
                    <i class="fa fa-upload" style={{ fontSize: "15px" }}></i>
                  }
                  onAccepted={(file) => setData(file[0])}
                  onReset={(file) => fUpload(data, planilla)}
                  resetButtonText="Subir Archivo"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card.Content>
      </Card>
    );
  };

  return (
    <div className="minTopPage">
      <Grid className="mx-0 mb-0 p-0">
        <Grid.Row>
          <TitlePage title="Despacho" />
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={12} sWidth={12} xsWidth={12}>
            <div className="spaceAmongDiv1">
              <Card style={{ minHeight: "310px" }}>
                <Card.Header title="CARGA DE DATOS">
                  <Icon name="increasing" root="common" />
                </Card.Header>
                <Card.Content>
                  <hr style={{ marginTop: "0px", marginBottom: "15px" }} />
                  <div className="spaceAmongDiv1">
                    <Grid.Row>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal("INFORME TURNO", "tostacionDMH")}
                      </Grid.Column>
                      <Grid.Column xsWidth={12} sWidth={12} width={6}>
                        {fGlobal("DATOS OPACOS", "OpacosDMH")}
                      </Grid.Column>
                    </Grid.Row>
                  </div>
                </Card.Content>
              </Card>
            </div>
          </Grid.Column>
        </Grid.Row>

        <Modal
          className="modalHeightHCarga p-1"
          closeIcon={true}
          onClose={() => setStateModal(!stateModal)}
          open={stateModal}
          closeOnDocumentClick={true}
          size="small"
        >
          <Modal.Header className="mt-4">
            <span className="modalTitleHeader letter-origin ps-3">
              El archivo se subío correctamente. Debe esperar que realicen los
              cambios en la base de datos.
            </span>
          </Modal.Header>

          <Modal.Footer className="pe-3">
            <Button
              type="inline-secondary"
              className="button-smaller"
              content="CERRAR"
              onClick={() => setStateModal(!stateModal)}
            />
          </Modal.Footer>
        </Modal>
      </Grid>
    </div>
  );
};
export default CargaData;
